export interface WordFormState {
    word: string | null;
    callParticipant: string | null;
    isActive: boolean | null;
}
